<template>
  <div>
    <div class="geekVideo">
      <div class="voteTitle" v-if="isVote">
        <p class="title1">{{ $t("works.光子国际艺术大赛人气奖投票截止！") }}</p>
        <p class="title2">
          {{
            $t(
              "works.即日起至11月10日，每位用户可为喜爱的参赛作品点赞（每个用户给每个作品限投1票）。"
            )
          }}
        </p>
        <p class="title2">
          {{
            $t(
              "works.截至2020年11月10日北京时间中午12:00，参赛作品点赞数累计最高者获得最佳人气奖。"
            )
          }}
        </p>
      </div>
      <div class="videoLeft">
        <div class="videoStart">
          <div class="sortType" v-if="isVote">
            <span
              @click="sortTypeList(0)"
              class="sortType2"
              :class="{ active: sortType == 0 }"
            >
              <img
                :src="
                  sortType == 0
                    ? '/static/v2/match/icon_sort_latest_active@2x.png'
                    : '/static/v2/match/icon_sort_latest@2x.png'
                "
                alt
              />{{ $t("works.最新加入") }}
            </span>
            <span
              @click="sortTypeList(1)"
              class="sortType1"
              :class="{ active: sortType == 1 }"
            >
              <img
                :src="
                  sortType == 1
                    ? '/static/v2/match/icon_sort_hotest_active@2x.png'
                    : '/static/v2/match/icon_sort_hotest@2x.png'
                "
                alt
              />{{ $t("works.人气最高") }}
            </span>
          </div>
          <div
            class="typeList"
            v-if="
              typeList.length > 0 &&
              colorString.config &&
              colorString.config.showCat
            "
          >
            <span
              :class="{ active: page == 0 }"
              @mouseover="hoverPage = 0"
              @mouseleave="hoverPage = null"
              :style="{
                background:
                  page == 0 || hoverPage == 0
                    ? colorString.works.worksHoverBg
                    : colorString.works.textCor,
                color:
                  page == 0 || hoverPage == 0
                    ? colorString.works.textCor
                    : colorString.works.worksHoverBg,
                border: '1px solid ' + colorString.works.worksHoverBg,
              }"
              @click="togger(0)"
            >
              {{ $t("global.全部") }}
              <!-- <i :style="{
                'color':(page==0||hoverPage == 0?colorString.works.textCor:colorString.works.worksHoverBg)
              }">{{allCount}}</i> -->
            </span>
            <span
              :class="{ active: page == i + 1 }"
              v-for="(item, i) in typeList"
              :key="i"
              @mouseover="hoverPage = i + 1"
              @mouseleave="hoverPage = null"
              :style="{
                background:
                  page == i + 1 || hoverPage == i + 1
                    ? colorString.works.worksHoverBg
                    : colorString.works.textCor,
                color:
                  page == i + 1 || hoverPage == i + 1
                    ? colorString.works.textCor
                    : colorString.works.worksHoverBg,
                border: '1px solid ' + colorString.works.worksHoverBg,
              }"
              @click="togger(i + 1, item.categoryId)"
            >
              {{ item.title }}
              <!-- <i
                :style="{
                'color':(page==i+1||hoverPage == i+1?colorString.works.textCor:colorString.works.worksHoverBg)
              }"
              >{{item.count}}</i> -->
            </span>
          </div>
          <ul v-if="homeVideolist.length">
            <li
              class="noscale"
              v-for="item in homeVideolist"
              :key="item.videoId"
            >
              <router-link
                :to="'/video/detail?id=' + item.videoId"
                target="_blank"
              >
                <img :src="item.videoThumb | imageUrl('', 550, 310)" />
                <div class="blackLayers"></div>
                <div class="blue"></div>
                <div class="popMask">
                  <img src="/static/v2/match/play_tri_40.png" alt />
                </div>
              </router-link>

              <div class="geekPersonal">
                <router-link
                  class="spaned"
                  :to="'/video/detail?id=' + item.videoId"
                  >{{ item.videoTitle }}</router-link
                >
                <div class="geekHead clearfix">
                  <router-link
                    :to="`/peopleCenter/` + item.userId"
                    class="geekheadSmall"
                  >
                    <img
                      :src="
                        item.userAvatar
                          | imageUrl('/static/profile_img_default.png', 40, 40)
                      "
                      alt
                    />
                    <span>{{ item.userNickname }}</span>
                  </router-link>
                  <!-- <span v-if="isVote" class="openVote" @click="DoLike(item)">
                    <img
                      :src="item.isLike?'/static/v2/match/vote_clap_actived@2x.png':'/static/v2/match/vote_clap@2x.png'"
                      alt
                    />
                    <span v-if="item.isLike">{{$t('works.已投票')}}：{{item.likeCount || 0}}</span>
                    <span v-if="!item.isLike">{{$t('works.投票')}}：{{item.likeCount || 0}}</span>
                  </span> -->
                  <span v-if="isVote" class="openVote" @click="endLink">
                    <span
                      >{{ $t("works.人气值") }}：{{ item.likeCount || 0 }}</span
                    >
                  </span>
                </div>
                <div class="seeWorks" v-if="matchObject.id == 1010">
                  <a
                    class="worksDetail"
                    :href="'/video/detail?id=' + item.videoId"
                    target="_blank"
                    >{{ $t("works.查看作品详情") }}</a
                  >
                  <a
                    v-if="item.realiBox"
                    class="addressOpen"
                    :href="item.realiBox"
                    target="_blank"
                    >{{ $t("works.查看在线互动DEMO") }}</a
                  >
                </div>
              </div>
            </li>
          </ul>
          <div v-else class="noDataImg">
            <img
              class="imgNo"
              src="/static/v2/match/video_empty@2x.png"
              alt=""
            />
            <p class="title">{{ $t("works.暂无参赛作品") }}</p>
          </div>
          <pagination
            :totalRecord="totalRecord"
            :pageSize="pageSize"
            :pageIndex="pageIndex"
            @OnCurrentChanged="changePage"
          />
        </div>

        <div
          class="number search-number yyu"
          style="margin: 0; margin-top: 15px; margin-bottom: -15px"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/lifePz.css";
import MainLayout from "@/layouts/MainLayout";
import Pagination from "@/components/v2/Pagination";

export default {
  name: "IndexPage",
  metaInfo() {
    return {
      title: this.$t("global.参赛作品") + " | MANA",
    };
  },
  components: {
    MainLayout,
    Pagination,
  },
  data() {
    return {
      contestName: null,
      homeVideolist: [],
      pageSize: 15,
      pageIndex: 1,
      totalRecord: 0,
      typeList: [],
      matchObject: {},
      allCount: 0,
      page: 0,
      hoverPage: null,
      categoryId: null,
      colorString: {},
      isVote: false,
      sortType: 0,
      // colorString: {
      //   nav: {
      //     //导航栏
      //     navBg: "#000000", //导航条底色
      //     textCor: "#FFFFFF", //文字颜色
      //     hoverNav: "#5C02BA" //hover导航条底色
      //   },
      //   share: {
      //     //分享
      //     shareBg: "#44FC00", //按钮背景色
      //     topBg: "#D2D2D2", //回到顶部背景色
      //     iconCor: 0 //icon颜色  0-白色 1-黑色
      //   },
      //   works: {
      //     //作品标签
      //     worksHoverBg: "#5243FF" //作品标签选择背景颜色
      //   },
      //   page: {
      //     //导航以下页面背景可配置背景图或颜色
      //     pageBg: "#ffffff", //背景颜色
      //     pageImg: "" //背景图
      //   }
      // }
    };
  },
  created() {
    this.init();
  },

  methods: {
    endLink() {
      this.$message(this.$t("works.投票已截止!"));
    },
    DoLike(item) {
      let $this = this;
      if (item.isLike) {
        this.$http
          .post("/api/u/relation/cancel/like/" + item.videoId)
          .then(function (response) {
            if (response) {
              // $this.getData();
              if (item.likeCount > 0) {
                item.likeCount--;
              }
              item.isLike = false;
              $this.$message($this.$t("global.取消点赞成功"));
            }
          });
      } else {
        this.$http
          .post("/api/u/relation/comment/" + item.videoId, {
            domainType: 1,
            type: 3,
          })
          .then(function (response) {
            if (response.code === "OK") {
              // $this.getData();
              item.likeCount++;
              item.isLike = true;
              $this.$message.success($this.$t("global.点赞成功"));
            }
          });
      }
    },
    togger(i, id) {
      this.page = i;
      this.categoryId = null;
      if (id) {
        this.categoryId = id;
      }
      this.gethomeVideolist();
    },
    init() {
      this.contestName = this.$route.params.contestName;
      if (this.contestName && this.contestName == '2020lighteningselection') {
        this.isVote = true;
        this.sortType = 0;
      }
      // if (sessionStorage.getItem("homeVideolist")) {
      //   this.homeVideolist = JSON.parse(
      //     sessionStorage.getItem("homeVideolist")
      //   );
      // }
      if (this.contestName) {
        this.$http
          .get("/api/nmatch/url/" + this.contestName)
          .then((response) => {
            this.matchObject = response.data;
            if (response.data.subjectContentCode !== '') {
              this.colorString = JSON.parse(response.data.subjectContentCode);
            }
            // this.allCount = response.data.videoCount;
            this.getTypeList();
            this.gethomeVideolist();
          });
      }
    },
    getTypeList() {
      this.$http
        .get("/api/match/category/" + this.matchObject.id)
        .then((response) => {
          this.typeList = response.data;
          // for (let i = 0; i < this.typeList.length; i++) {
          //   this.allCount += this.typeList[i].count;
          // }
        });
    },
    sortTypeList(type) {
      if (this.sortType !== type) {
        this.sortType = type;
        this.pageIndex = 1;
        this.gethomeVideolist();
      }
    },
    gethomeVideolist(id) {
      let $this = this;
      this.$http
        .get("/api/match/video/list2", {
          params: {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            matchId: this.matchObject.id,
            categoryId: this.categoryId,
            orderByType: this.sortType,
          },
        })
        .then(function (response) {
          $this.homeVideolist = response.data.list;
          $this.totalRecord = response.data.totalRecord;
        });
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex;
      this.gethomeVideolist();
    },
  },
};
</script>
<style scoped>
.videoStart {
  border: none;
  min-height: calc(100vh - 745px);
}
.videoStart .typeList {
  padding-bottom: 18px;
}
.videoStart .typeList span {
  display: inline-block;
  min-width: 90px;
  padding: 0 20px;
  margin-bottom: 12px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  border-radius: 20px;
  margin-right: 10px;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-weight: 600;
  box-sizing: border-box;
  cursor: pointer;
}
.videoStart .typeList span i {
  margin-left: 8px;
  font-size: 14px;
  opacity: 0.6;
  filter: alpha(opacity=60);
  vertical-align: 1px;
  font-weight: 600;
}
.videoStart .typeList span:hover {
  background: rgba(0, 0, 0, 1);
  color: rgba(255, 255, 255, 1);
}
.videoStart .typeList span.active {
  background: rgba(0, 0, 0, 1);
  color: rgba(255, 255, 255, 1);
}
.noscale {
  position: relative;
}
.noscale .popMask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: none;
}
.noscale .popMask img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 40px;
}
.noscale a:hover .popMask {
  display: block;
}
.noDataImg {
  text-align: center;
  padding: 120px 0;
}
.noDataImg .imgNo {
  width: 88px;
  height: 88px;
}
.noDataImg .title {
  font-size: 15px;
  font-weight: 400;
  color: #b8b8b8;
  margin-top: 30px;
}
</style>




// WEBPACK FOOTER //
// src/pages/match/works.vue